/* Belonge Redesign — PDP colour-aware gallery. Loaded after belonge.js.

   Evidence used to decide which photo belongs to which colour, strongest first:
   1. the image filename or alt text naming a colour ("…purple-front.jpg");
   2. a variant's featured image;
   3. position — an unlabelled photo belongs to the last labelled photo above it.
   Photos above the first labelled one are treated as shared and show with every
   colour. To get an exact split, name the image files (or alt text) after the
   colour in admin. */
(function () {
  if (window.__belongeGalleryBooted) return;
  window.__belongeGalleryBooted = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  function init(root) {
    var dataEl = $('[data-bl-variants]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var optNames = (root.dataset.blOptionNames || '').split('||');
    var colorIdx = -1;
    optNames.forEach(function (n, i) { if (colorIdx < 0 && /colou?r/i.test(n)) colorIdx = i; });
    if (colorIdx < 0) return;

    var mediaEls = $$('[data-bl-media]', root);
    if (!mediaEls.length) return;
    var sel = '[data-bl-opt-index="' + colorIdx + '"]';
    var colors = $$('button' + sel, root).map(function (b) { return b.dataset.blOpt; }).filter(Boolean);
    if (!colors.length) return;
    var mode = root.dataset.blGalleryMode || 'group';
    var order = mediaEls.map(function (el) { return String(el.dataset.blMedia); });
    var owner = new Array(mediaEls.length);

    /* 2. variant featured image */
    data.forEach(function (v) {
      if (!v.featuredMediaId) return;
      var i = order.indexOf(String(v.featuredMediaId));
      if (i > -1 && owner[i] === undefined) owner[i] = v.options[colorIdx];
    });

    /* 1. filename / alt text wins — longest unambiguous colour name */
    mediaEls.forEach(function (el, j) {
      var hay = norm((el.getAttribute('alt') || '') + ' ' + (el.getAttribute('src') || '').split('?')[0]);
      if (!hay) return;
      var hits = colors.filter(function (c) { return norm(c) && hay.indexOf(norm(c)) > -1; })
        .sort(function (a, b) { return norm(b).length - norm(a).length; });
      if (hits.length === 1 || (hits.length > 1 && norm(hits[0]).length > norm(hits[1]).length)) owner[j] = hits[0];
    });

    /* 3. carry the last known colour down the strip */
    if (mode !== 'lead') {
      var cur;
      for (var j = 0; j < mediaEls.length; j++) {
        if (owner[j] !== undefined) cur = owner[j];
        else if (cur !== undefined) owner[j] = cur;
      }
    }
    var known = owner.some(function (o) { return o !== undefined; });

    function apply(val) {
      var v = norm(val);
      var mineCount = owner.filter(function (o) { return o !== undefined && norm(o) === v; }).length;
      var split = known && mineCount > 0;
      mediaEls.forEach(function (el, j) {
        var o = owner[j];
        var mine = o !== undefined && norm(o) === v;
        el.hidden = split ? !(mine || o === undefined) : false;
        el.style.order = String(split && mine ? j - 1000 : j);
      });
      var shown = mediaEls.filter(function (el) { return !el.hidden; });
      if (shown[0]) { shown[0].setAttribute('fetchpriority', 'high'); shown[0].removeAttribute('loading'); }
      $$('[data-bl-optcount="' + colorIdx + '"]', root).forEach(function (el) {
        el.textContent = shown.length + (shown.length === 1 ? ' photo' : ' photos');
      });
    }

    function current() {
      var p = $('button' + sel + '[aria-pressed="true"]', root);
      return p ? p.dataset.blOpt : colors[0];
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('button' + sel);
      if (btn) setTimeout(function () { apply(btn.dataset.blOpt || current()); }, 0);
    });
    apply(current());
  }

  function boot() {
    var pdp = $('[data-bl-pdp]');
    if (pdp) { try { init(pdp); } catch (e) { console.warn('[belonge] gallery init', e); } }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
